<template>
  <component ref="step" class="step h-full pr-4 lg:pr-10"
    summary-width="md:w-11.5/12 lg:max-w-detailinvoice flex-none"
    :is-first-step="curStep === firstStep || curStep === dynFirstStep"
    :is="currentStep.component"
    :step="currentStepMin"
    v-model="idCliente"
    :collapsed="isSummaryCollapsed"
    @input="updateDynFirstStep"
    @update:collapsed="setSummaryCollapsed"
    @reset="resetForm"
    @applystep="submitForm">
    <template slot="header"> 
      <div class="loader" v-if="isGeneralLoading">
        <loading :opacity="0" :active.sync="isGeneralLoading" color="var(--primary-DEFAULT)"></loading>
      </div>
      <base-header icon="user2" :content="header" />
      <div class="steps-wrapper pl-4 lg:pl-10 mb-2 lg:mb-4" >
        <el-steps class="w-full md:flex" finish-status="success" :active="curStep" simple>
          <el-step v-for="(step, index) in steps" :key="index" :status="step.status" :title=" isLower1024 ? '' : step.title">
            <template #title>
              <div>
                <a v-if="(step.status !== 'wait' || (steps[index-1] && steps[index-1].status === 'success')) && curStep !== index" @click="goToStep(index)" class="space-x-2 cursor-pointer">
                  <base-icon :name="step.icon" size="sm" />
                  <span v-if="!isLower1650">{{step.title}}</span>
                </a>
                <div v-else class="space-x-2 cursor-not-allowed">
                  <base-icon :name="step.icon" size="sm" />
                  <span v-if="!isLower1650">{{step.title}}</span>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
    </template>
    <template slot="invoice-summary">
      <div class="form-wrapper invoice-summary pr-4 lg:pr-10 pt-2 lg:pt-4 ">
        <el-form :model="form" ref="ruleForm">
          <div class="hideHScroll">
            <div class="summary-line flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('invoices.num_factura_short')" :data="numFactura" />
              </div>
              <div class="px-2 w-full mb-2 flex justify-between" >
                <base-ro-input-inline :label="$t('invoices.serie_factura_short')" :data="serieFactura" />
              </div>
            </div>
            <div class="summary-line flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('invoices.emisor')" :data="RazonSocial" />
              </div>
              <div class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('invoices.cif_emisor')" :data="CIF" />
              </div>
            </div>
            <div v-if="issuingType !== 4" class="summary-line flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('invoices.receptor')" :data="NameCorporateName" class="text-right" />
              </div>
              <div class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('invoices.cif_receptor')" :data="TIN" />
              </div>
            </div>
            <div class="summary-line flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('invoices.fecha_emision')" :data="dateEmision" />
              </div>
              <div v-if="issuingType !== 4" class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('app.forma_envio')" :data="FormaEnvio" />
              </div>
            </div>
            <div class="summary-line flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 flex justify-between">
                <base-ro-input-inline :label="$t('invoices.total_invoice')" :data="importe" />
              </div>
            </div>

            <div class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $tc('invoices.invoices_issuing.step4.header',lineas.length === 1 ? 1 : 2) }}</h3>
              <el-table ref="lineas" :data="lineas" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="lineas && lineas.length > 0">
                <el-table-column prop="LineaF" :label="$t('invoices.invoices_issuing.linea')" min-width="50" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="DescripcionF" :label="$t('invoices.invoices_issuing.descripcion')" min-width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="CantidadF" :label="$t('invoices.invoices_issuing.step4.cantidad')" min-width="120" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="TotalF" :label="$t('app.total')" min-width="120" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>

            <div class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.importes') }}</h3>
              <el-table ref="importes" :data="importes" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="importes && importes.length > 0">
                <el-table-column prop="Base" :label="$t('invoices.taxable_base')" show-overflow-tooltip>
                </el-table-column>
                <!-- isLower1650 ? $t('app.type')+' (%)': -->
                <el-table-column prop="TipoP" :label="$t('invoices.tax_rate')" min-width="153" show-overflow-tooltip>
                </el-table-column>
                <!-- isLower1650 ? $t('invoices.importe'): -->
                <el-table-column prop="Importe" :label="$t('invoices.tax_amount')" min-width="150" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>
            <div class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.invoices_documents') }}</h3>
              <el-table ref="documentos" :data="Adjuntos" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="Adjuntos && Adjuntos.length > 0">
                <el-table-column prop="tipo" width="36" align="center">
                  <template slot-scope="tipos">
                    <el-tooltip v-if="tipos.row.tipo" placement="left">
                      <div slot="content">
                        <div class="max-w-sm max-h-500p overflow-auto">
                          <div v-if="tipos.row.tipo === 'xml'">{{ $t('invoices.xml_invoice') }}</div>
                          <div v-else>{{ $t('invoices.document_adj_emb_long') }}</div>
                        </div>
                      </div>
                      <base-icon :name="tipos.row.tipo" />
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="Nombre" :label="$tc('app.documents', 1)" min-width="140" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="Extension" :label="$t('app.extension')" width="90">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template v-slot:layout-extend="{ valid, loading }">
      <base-footer :set="isLoading = ![undefined, null].includes(loading) ? !!loading : isGeneralLoading">
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="toogleResetDialog" :loading="loading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="hasPrevStep" mode="secondary" :text="$t('app.back')" icon="back" @click="prevStep" :loading="loading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="hasNextStep" mode="primary" :text="$t('app.next')" icon="check" @click="submitForm" :loading="loading" :disabled="isGeneralLoading || !valid" />
          <template v-if="!hasNextStep">
            <base-table-select-more-actions-form v-if="isInInvoicesIssuingType || isInSimplifiedIssuingType" :name="$t('app.save')" custom-class="bg-secondary-800" :loading="loading" :disabled="isGeneralLoading || !valid" @mainclick="uploadForm(false)">
              <template slot="more">
                <span>
                  <base-button-item-list theme="dark" @click="uploadForm(false)" :loading="loading" :disabled="isGeneralLoading || !valid">
                    <base-icon name="save" class="mr-2" />
                    <div class="w-72 text-left">
                      {{ $t('app.save') }}
                    </div>
                  </base-button-item-list>
                </span>
                <span>
                  <base-button-item-list theme="dark" @click="uploadForm(true)" :loading="loading" :disabled="isGeneralLoading || !valid">
                    <base-icon name="send" class="mr-2" />
                    <div class="w-72 text-left">
                      {{ $t('app.save_and_send') }}
                    </div>
                  </base-button-item-list>
                </span>
              </template>
            </base-table-select-more-actions-form>
            <base-button-responsive v-else mode="primary" :text="$t('app.save')" icon="save" @click="uploadForm(false)" :loading="loading" :disabled="isGeneralLoading || !valid" />
          </template>
        </template>
      </base-footer>
      <Dialog :title="$t('app.form_changes_dialog_header')" :visible.sync="showModalReset" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="toogleResetDialog" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.exit')"
              @click="submitResetDialog" />
          </div>
        </template>
      </Dialog>
    </template>
  </component>
</template>

<script>
import { i18n } from '@/i18n'

import Loading from 'vue-loading-overlay'
import { Dialog } from 'element-ui'
import Step01Partes from '@/views/invoices/issuingSteps/Step01Partes.vue'
// import Step0Issuer from '@/views/invoices/issuingSteps/Step0Issuer.vue'
// import Step1Receiver from '@/views/invoices/issuingSteps/Step1Receiver.vue'
import Step2Detail from '@/views/invoices/issuingSteps/Step2Detail.vue'
// import Step3Others from '@/views/invoices/issuingSteps/Step3Others.vue'
import Step4Line from '@/views/invoices/issuingSteps/Step4Line.vue'
// import Step5Totals from '@/views/invoices/issuingSteps/Step5Totals.vue'
import Step6Payment from '@/views/invoices/issuingSteps/Step6Payment.vue'
import Step7Attachments from '@/views/invoices/issuingSteps/Step7Attachments.vue'

import { bus } from '@/main'
import { uploadFacturae } from '@/services/configurations/uploadFacturae'
import { uploadSimplificada } from '@/services/configurations/uploadSimplificada'
import { uploadProformaPresupuesto } from '@/services/configurations/uploadProformaPresupuesto'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import getPayloadFacturae from '@/services/functions/getPayloadFacturae'
import getPayloadSimplificada from '@/services/functions/getPayloadSimplificada'
import { checkInvoiceNumber } from '@/services/configurations/checkInvoiceNumber'
// import replaceRouteParams from '@/services/functions/replaceRouteParams'

export default {
  name: 'invoice-issuing',
  components: {
    Loading,
    Dialog
  },
  data () {
    return {
      idCliente: '',
      oldIdCliente: '',
      dynFirstStep: -1,
      isGeneralLoading: false,
      showModalReset: false,
      processMessage: i18n.t('app.form_changes_dialog_message'),
      localCurStep: 0,
      stepHeight: '12px'
    }
  },
  computed: {
    ...mapGetters('invoicesIssuing', ['isSummaryCollapsed', 'form', 'issuingTypes', 'issuingType', 'issuingTypeStr', 'isInIssuingType']),
    isInInvoicesIssuingType: function () {
      return this.isInIssuingType(1)
    },
    isInSimplifiedIssuingType: function () {
      return this.isInIssuingType(4)
    },
    paramIssuingType: function () {
      const type = Number.parseInt(this.$route.params?.issuingType)
      if (Object.values(this.issuingTypes).includes(type)) {
        return type
      }
      return 1
    },
    headerTitle: function () {
      switch (this.issuingType) {
        case 4:
          return i18n.t('invoices.invoices_issuing.simplified.header_long')
        case 3:
          return i18n.t('invoices.invoices_issuing.quotation.header_long')
        case 2:
          return i18n.t('invoices.invoices_issuing.proforma.header_long')
        case 1:
        default:
          return i18n.t('invoices.invoices_issuing.header_long')
      }
    },
    header: function () {
      return {
        title: this.headerTitle,
        icon: 'docblack',
        breadcrumb: null,
        nav: [],
        url: null
      }
    },
    // #region Step Data
    steps: function () {
      const steps = [
        { stepId: '01', title: i18n.t('invoices.invoices_issuing.step01.short_header'), icon: 'group', description: i18n.t('invoices.invoices_issuing.step01.header'), component: Step01Partes, status: 'process' },
        // { stepId: '0', title: i18n.t('invoices.emisor'), icon: '', description: i18n.t('invoices.invoices_issuing.step0.header'), component: Step0Issuer, status: 'wait' },
        // { stepId: '1', title: i18n.t('invoices.receptor'), icon: '', description: i18n.t('invoices.invoices_issuing.step1.header'), component: Step1Receiver, status: 'wait' },
        { stepId: '2', title: i18n.t('app.detail'), icon: 'detail', description: i18n.t('invoices.invoices_issuing.step2.header'), component: Step2Detail, status: 'wait' },
        { stepId: '4', title: i18n.t('invoices.invoices_issuing.step4.line_plural'), icon: 'list-numbers', description: i18n.tc('invoices.invoices_issuing.step4.header', 1), component: Step4Line, status: 'wait' },
        // { stepId: '3', title: i18n.t('invoices.invoices_issuing.step3.header'), icon: '', description: i18n.t('invoices.invoices_issuing.step3.header'), component: Step3Others, status: 'wait' },
        // { stepId: '5', title: i18n.t('invoices.invoices_issuing.totales'), icon: '', description: i18n.t('invoices.invoices_issuing.step5.header'), component: Step5Totals, status: 'wait' },
        { stepId: '6', title: i18n.t('invoices.invoices_issuing.pago'), icon: 'euro', description: i18n.t('tipos.metadata.pago'), component: Step6Payment, status: 'wait' },
        { stepId: '7', title: i18n.t('invoices.invoices_issuing.step7.header'), icon: 'clip', description: i18n.t('invoices.invoices_issuing.step7.header'), component: Step7Attachments, status: 'wait' },
      ]
      const indexes = steps.reduce((acc, step, i) => ({ ...acc, [step.stepId]: i }), {})
      if (this.issuingType === 2) {
        steps[indexes['2']].description = i18n.t('invoices.invoices_issuing.step2.p_header')
        steps[indexes['4']].description = i18n.tc('invoices.invoices_issuing.step4.p_header', 1)
      } else if (this.issuingType === 3) {
        steps[indexes['2']].description = i18n.t('invoices.invoices_issuing.step2.q_header')
        steps[indexes['4']].description = i18n.tc('invoices.invoices_issuing.step4.q_header', 1)
      } else if (this.issuingType === 4) {
        steps.splice(indexes['6'], 1)
      }
      return steps
    },
    curStep: function () {
      return this.$store.getters['invoicesIssuing/curStep']
    },
    currentStep: function () {
      if (this.hasNextStep) {
        return this.steps[this.curStep]
      }
      return this.steps.at(-1)
    },
    currentStepMin: function () {
      if (this.currentStep) {
        return this.discard(['component'], this.currentStep)
      }
      return undefined
    },
    hasFirstStep: function () {
      return true
    },
    firstStep: function () {
      return Number(!this.hasFirstStep)
    },
    isLastStep: function () {
      return this.curStep === parseInt(this.steps.length - 1)
    },
    hasPrevStep: function () {
      return this.curStep > this.firstStep
    },
    hasNextStep: function () {
      return !!(this.curStep < this.steps.length - 1)
    },
    // #endregion
    hasAutoFacturaModule: function () {
      return this.$store.getters['auth/hasAutofacturaModule']
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    hasOperationType: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.tipoImpuestoFactura
    },
    // #region Responsive
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isLower1650: function () {
      return this.$store.getters['app/getIsLower1650']
    },
    // #endregion
    // #region Summary Data
    numFactura: function () {
      return this.form?.numFactura ?? ''
    },
    serieFactura: function () {
      return this.form?.serieFactura ?? ''
    },
    RazonSocial: function () {
      return this.form?.issuer?.RazonSocial ?? ''
    },
    CIF: function () {
      return this.form?.issuer?.CIF ?? ''
    },
    idCIFEmpresa: function () {
      return this.$store.getters['invoicesIssuing/form']?.issuer?.IdCIFEmpresa || ''
    },
    NameCorporateName: function () {
      return this.form?.receiver?.Sociedad?.NameCorporateName ?? ''
    },
    TIN: function () {
      return this.form?.receiver?.Sociedad?.TIN ?? ''
    },
    dateEmision: function () {
      const dateNumber = Date.parse(this.form.dateEmision)
      return !Number.isNaN(dateNumber) ? i18n.d(dateNumber, 'numeric_date', { date: '-' }) : ''
    },
    InvoiceLines: function () {
      return this.form?.invoiceLines ?? []
    },
    // CuotaSuplido: function () {
    //   return this.form?.cuotaSuplido ?? ''
    // },
    TotalAmounts: function () {
      if (!this.InvoiceLines?.length) {
        return null
      }
      return this.InvoiceLines.reduce((acc, line) => ({
        TotalGrossAmount: acc.TotalGrossAmount + line.subtotal,
        TotalGeneralDiscounts: acc.TotalGeneralDiscounts + (line.descuentos || []).reduce((dAcc, desc) => dAcc + desc.cuota, 0),
        TotalGrossAmountBeforeTaxes: acc.TotalGrossAmountBeforeTaxes + line.total,
        TotalTaxOutputs: this.hasOperationType ? 0 : acc.TotalTaxOutputs + (line.taxes || []).reduce((tAcc, tax) => tAcc + tax.cuota, 0),
      }), {
        TotalGrossAmount: 0,
        TotalGeneralDiscounts: 0,
        TotalGrossAmountBeforeTaxes: 0,
        TotalTaxOutputs: 0,
      })
    },
    TotalTaxesWithheld: function () {
      const totalAmounts = this.TotalAmounts
      if (this.form.irpf) {
        return totalAmounts.TotalGrossAmount * this.form.irpf.TaxRate /100
      }
      return 0
    },
    InvoiceTotal: function () {
      // const suplido = parseInt(this.CuotaSuplido)
      const totalAmounts = this.TotalAmounts
      if (!totalAmounts) {
        return ''
      }
      return totalAmounts.TotalGrossAmountBeforeTaxes + totalAmounts.TotalTaxOutputs - this.TotalTaxesWithheld
    },
    importe: function () {
      const totalFactura = this.InvoiceTotal
      return Number.isFinite(totalFactura) ? i18n.n(totalFactura, 'currency') : ''
    },
    FormaEnvio: function () {
      const sendType = new Set(this.$store.getters['config/TIPOS_PGE'].concat(this.$store.getters['config/TIPOS_PGE_RECEPCION']).map(JSON.stringify))
      const tiposEnvio = Array.from(sendType).map(JSON.parse)
      return tiposEnvio.find(x => x.id === this.form?.receiver?.SendType)?.name || this.form?.receiver?.SendType
    },
    lineas: function () {
      return (this.$store.getters['invoicesIssuing/lineas'] || []).map(line => ({
        ...line, 
        LineaF: i18n.n(line.NumeroLinea, 'integer'),
        DescripcionF: line.Descripcion,
        CantidadF: i18n.n(line.Cantidad, 'decimal'),
        TotalF: i18n.n(line.Total, 'currency_8')
      }))
    },
    importes: function () {
      return (this.$store.getters['invoicesIssuing/impuestos'] || []).map(tax => ({
        ...tax, 
        Base: i18n.n(tax.BaseImponible, 'currency_8'),
        TipoP: i18n.n(tax.Tipo, 'percent'),
        Importe: i18n.n(tax.Cuota, 'currency_8')
      }))
    },
    Adjuntos: function () {
      const adjuntos = [...(this.form?.Adjuntos ?? [])]
      if (this.form?.template) {
        adjuntos.unshift(this.formatTemplate(this.form.template))
      } else if (this.form?.file) {
        adjuntos.unshift(...this.form.file)
      }
      return adjuntos
    },
    // #endregion
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
  },
  watch: {
    localCurStep: function (value, oldValue) {
      if (value !== oldValue) {
        this.goToStep(value)
      }
    },
    curStep: function (value, oldValue) {
      if (value !== oldValue) {
        this.localCurStep = value
      }
    },
    paramIssuingType: function (value, oldValue) {
      if (value !== oldValue) {
        this.$store.commit('invoicesIssuing/setIssuingType', value)
        this.resetForm()
      }
    }
  },
  mounted () {
    this.localCurStep = this.curStep
    if (this.$refs.hstep) {
      const height = this.$refs.hstep.offsetHeight || this.$refs.hstep[0].offsetHeight || 12
      this.stepHeight = `calc(${height}px / 2)`
    }
    if (this.isIssuingCreation) {
      this.$store.dispatch('app/exitMode', 1)
    }
  },
  created: function () {
    this.$store.commit('invoicesIssuing/setIssuingType', this.paramIssuingType)
    if (!this.isIssuingCreation) {
      this.resetForm({ created: true })
    } else {
      this.idCliente = this.form.issuer.IdCliente
      this.localCurStep = this.curStep
      for (let index = 0; index < this.curStep; index++) {
        this.setStepStatus(index, 'success')
      }
      this.setStepStatus(this.curStep, 'process')
    }
  },
  methods: {
    ...mapMutations('invoicesIssuing', ['setCurStep', 'setSummaryCollapsed']),
    ...mapActions('invoicesIssuing', ['nextStep', 'previousStep']),
    prevStep: function () {
      const stepFrom = this.curStep 
      const nextStep = this.steps[this.curStep +1]
      this.isGeneralLoading = true
      if (this.hasPrevStep) {
        this.$refs.step.validate(valid => {
          if (this.isLastStep || nextStep.status === 'wait' || (typeof valid === 'boolean' && valid)) {
            this.setStepStatus(stepFrom, (valid instanceof Error) || !valid ? 'wait': 'success')
            this.previousStep()
            this.setStepStatus(this.curStep, 'process')
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } else {
        this.resetForm()
      }
      this.isGeneralLoading = false
    },
    submitForm: async function () {
      this.isGeneralLoading = true
      this.$refs.step.validate((valid, error) => {
        if (valid && typeof valid !== 'string' && !(valid instanceof Error)) {
          if (this.hasNextStep) {
            this.setStepStatus(this.curStep, 'success')
            this.nextStep()
            this.setStepStatus(this.curStep, 'process')
          } else {
            this.resetForm()
          }
        } else {
          if (error) {
            if (error instanceof Error && error.message) {
              this.doFeedback(error.message)
            } else {
              this.doFeedback(error)
            }
          } else if (typeof valid === 'string') {
            this.doFeedback(valid)
          } else if (valid instanceof Error && valid.message) {
            this.doFeedback(valid.message)
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        }
        this.isGeneralLoading = false
      })
    },
    uploadForm: async function (send) {
      this.isGeneralLoading = true
      const params = { idCIFEmpresa: this.form.issuer.IdCIFEmpresa, envio: send }

      try {
        const invoiceNumPayload = {
          idCliente: this.idCliente,
          idCIFEmpresa: this.idCIFEmpresa,
          serieFactura: this.serieFactura,
          numeroFactura: this.numFactura,
          fechaFactura: this.form.dateEmision 
        }
        const data = await checkInvoiceNumber(invoiceNumPayload)
        if (data.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else if (!data.Respuesta) {
          this.doFeedback(i18n.t('invoices.invoices_issuing.step2.num_factura_error'))
        } else {
          let response = null
          if (this.isInSimplifiedIssuingType) {
            const payload = await getPayloadSimplificada(this.form)
            response = await uploadSimplificada(payload, params)
          } else {
            const facturaePayload = await getPayloadFacturae(this.form)
            if (this.isInInvoicesIssuingType) {
              response = await uploadFacturae(facturaePayload, params)
            } else {
              params.typeFactura = this.issuingTypeStr
              delete params.envio
              response = await uploadProformaPresupuesto(facturaePayload, params)
            } 
          }
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            bus.$emit('changeIt')
          }
        }
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.isGeneralLoading = false
      }
    },
    submitResetDialog: function () {
      this.toogleResetDialog()
      this.resetForm()
    },
    // toogleResetDialog: function (oldIssuer = '') {
    //   this.changeIssuer = oldIssuer
    //   this.showModalReset = !this.showModalReset
    // },
    toogleResetDialog: function () {
      this.showModalReset = !this.showModalReset
    },
    convertFileToBase64: async function (file) {
      if (file.raw) {
        const adjunto = await new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result.split(',')[1]) // Extraemos solo el base64 (sin el encabezado 'data:...')
          reader.onerror = (error) => reject(error)
          reader.readAsDataURL(file.raw) // Leemos el archivo como un DataURL
        })
        return {
          Nombre: file.Nombre,
          Mime: file.Extension,
          contenidoB64: adjunto // Adjunto en base64
        }
      } else {
        return null
      }
    },
    resetForm: async function ({ created = false, excluded = [] } = {}) {
      await this.$store.dispatch('invoicesIssuing/resetForm', excluded)
      if (!this.hasPrevStep && !created) {
        this.$refs.step.resetForm(excluded)
      }
      this.steps.forEach(element => { element.status = 'wait' })
      this.steps[0].status = 'process'
      this.idCliente = ''
      this.setCurStep(this.firstStep)
    },
    formatTemplate (template) {
      var name = []
      if (this.form.numFactura !== '') {
        name.push(this.form.numFactura)
      }
      if ((this.form.issuer?.CIF ?? '') !== '') {
        name.push(this.form.issuer.CIF)
      }
      if (this.form.dateEmision !== '') {
        const date = new Date(this.form.dateEmision)
        if (!Number.isNaN(date.getTime())) {
          name.push(date.getFullYear())
        }
      }
      const finalName = name.length ? name.join('_') : 'factura'
      return {
        ...template,
        Nombre: `${finalName}.pdf`,
        tipo: 'pdf',
        Extension: 'pdf',
        icon: 'eye',
        visible: false
      }
    },
    setStepStatus: function (index, status) {
      this.$set(this.steps[index], 'status', status)
    },
    goToStep: function (index, reset = false) {
      const stepFrom = this.curStep
      const nextStep = this.steps[this.curStep +1] 
      if (stepFrom !== index && !reset) {
        this.$refs.step.validate(valid => {
          if ((valid && !(valid instanceof Error)) || (this.isLastStep || nextStep.status === 'wait')) {
            valid = valid instanceof Error ? false : valid
            this.setStepStatus(index, 'process')
            this.setStepStatus(stepFrom, valid ? 'success' : 'wait')
            this.setCurStep(index)
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      }
    },
    updateDynFirstStep: function (value) {
      if (value !== this.oldIdCliente) {
        this.dynFirstStep = value !== '' ? this.curStep : -1
        this.oldIdCliente = value
      }
    }
  },
  beforeDestroy () {
    if (!this.isIssuingCreation) { 
      this.resetForm({ created: true })
    }
  },
}
</script>

<style scoped>
.el-steps .el-step::v-deep .el-step__title {
  white-space: nowrap;
  /* @apply truncate */
}
.el-steps .el-step::v-deep .el-step__icon {
  display: none;
}
::v-deep .content-wrapper {
  width: 100%;
  overflow-x: hidden;
}

@media (width < 1650px){
  .summary-line{
    display: flex;
    flex-direction: column;
  }
}
/* @media screen and (max-width: 425px) {
  .steps-wrapper {
    display: none;
  }
} */

.hideHScroll {
  overflow-x: hidden;
}
</style>
